export default __webpack_public_path__ + "static/media/ellipse3.978163d2.svg";